//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import iconBaseInfo from '@/assets/img/icon_baseInfo.png'
import iconPicture from '@/assets/img/icon_picture.png'
import iconVolunteer from '@/assets/img/icon_volunter.png'
import iconStudyExp from '@/assets/img/icon_studyExp.png'
import iconFamily from '@/assets/img/icon_family.png'
import iconAttachment from '@/assets/img/icon_attachment.png'
import myLogo from '@/assets/img/my-logo.png'
import {
  cancelEnroll,
  checkBaseRequire,
  downloadEnrollTable,
  queryEnrollDetail,
  submitEnroll,
} from '@/https/enroll'
import {
  mapActions,
  mapState,
} from 'vuex'
import {
  danger,
  success,
} from '@/utils/notify.js'
import { toast } from '@/utils/toast'
import { confirm } from '@/utils/dialog'
import {
  CHECK_STATUS,
  checkFilterTool,
} from '@/constant/dict'

export default {

  data () {
    return {
      CHECK_STATUS,
      enrollConfigAllData: {},
      iconBaseInfo,
      iconPicture,
      iconVolunteer,
      iconStudyExp,
      iconFamily,
      myLogo,
      statusWarningHtml: '',
      userData: {},
      projectConfig: {},
      loading: false,
      menuList: [],
      isModify: this.$route.query.type === 'modify',
    }
  },

  computed: {
    ...mapState('enroll', ['batchInfo']),
    tagType () {
      return CHECK_STATUS.find((el) => +el.status === +this.userData.shztdm)?.btn || 'default'
    },

    tagTitle () {
      return CHECK_STATUS.find((el) => +el.status === +this.userData.shztdm)?.text || '未知'
    },

    canEdit () {
      return !checkFilterTool.isPassCheck(this.userData.shztdm)
    },

    submitBtnShow () {
      return checkFilterTool.isNotCheck(this.userData.shztdm) ||
      checkFilterTool.isRefuseCheck(this.userData.shztdm)
    },

    previewBtnShow () {
      return !checkFilterTool.isNotCheck(this.userData.shztdm)
    },

    recycleBtnShow () {
      return checkFilterTool.canRecycle(this.userData.shztdm)
    },
  },

  async created () {
    this.setEnrollConfigAllData()
  },

  methods: {
    ...mapActions('enroll', [
      'setBatchInfo',
      'setEnrollInfo',
    ]),
    async setEnrollConfigAllData () {
      this.loading = true

      const { pcdm, dzlbdm } = this.$route.query

      const { data } = await queryEnrollDetail({
        dzlbdm,
        pcdm,
      })

      this.enrollConfigAllData = data || {}

      this.setMenuList()
      this.loading = false
    },

    filterDataExtendField (key) {
      return this.enrollConfigAllData.bmbMbDetailItem?.bmbTzzdList?.find((el) => el.zdmc === key) || {}
    },

    async setMenuList () {
      const { bmbMbDetailItem: configData,
        fjList: attachmentList,
        jtcyList: familyList,
        ksxxItem: baseInfo,
        xxjlList: studyList } = this.enrollConfigAllData

      this.userData = {
        logo: baseInfo.zpdz,
        xm: baseInfo.xm,
        shyj: baseInfo.shyj,
        zjhm: baseInfo.zjhm,
        shztdm: baseInfo.shztdm,
        wid: baseInfo.wid,
      }

      await this.setStatusHtml(baseInfo)
      const familyConfig = this.filterDataExtendField('家庭成员')
      const studyConfig = this.filterDataExtendField('学习经历')
      this.menuList = [
        {
          title: '基本信息',
          link: 'baseInfoWrite',
          icon: iconBaseInfo,
          isRequired: true,
          hasWriteFlag: !!baseInfo.wid,
        },
        {
          title: '照片信息',
          link: 'userLogoUpload',
          icon: iconPicture,
          isDisplay: +configData.sfxysczpdm,
          isRequired: true,
          hasWriteFlag: !!baseInfo.zpdz?.length,
          statusText: baseInfo.zpdz?.length ? '已上传' : '未上传',
        },
        {
          title: '志愿信息',
          link: 'voluntInfoWrite',
          icon: iconVolunteer,
          isRequired: true,
          isDisplay: +configData.sfxytxzydm,
          hasWriteFlag: !!baseInfo.zsjh1Wid?.length,
        },
        {
          title: studyConfig.xsmc,
          link: 'studyExperienceWrite',
          icon: iconStudyExp,
          isRequired: +studyConfig.sfbtdm === 1,
          isDisplay: +studyConfig.sfxsdm,
          hasWriteFlag: !!studyList.length,
        },
        {
          title: familyConfig.xsmc,
          link: 'familyInfoWrite',
          icon: iconFamily,
          isRequired: +familyConfig.sfbtdm === 1,
          isDisplay: +familyConfig.sfxsdm,
          hasWriteFlag: !!familyList.length,
        },
        {
          title: '附件信息',
          link: 'attachmentInfo',
          icon: iconAttachment,
          isRequired: +configData.fjsfbtdm,
          isDisplay: +configData.fjyqdm !== 1,
          hasWriteFlag: !!attachmentList.length,
        },
      ]
    },

    setStatusHtml (batchInfo) {
      const status = batchInfo.shztdm

      if (checkFilterTool.isNotCheck(status) || checkFilterTool.initCheck(status)) {
        // const date = formatTime(this.batchInfo?.bmjssj)
        const date = this.$route.query.jzsj
        this.statusWarningHtml = `<div style="background: rgba(255, 153, 0, 0.1); padding: 0.62500rem 0.93750rem;">请在
        <span style="color: var(--warning)">${date}</span>之前提交报名信息，否则将无法报名</div>`
      }

      if (checkFilterTool.isWaitCheck(status)) {
        this.statusWarningHtml = '<div style="background: rgba(255, 153, 0, 0.1); padding: 0.62500rem 0.93750rem;">你已成功提交报名信息，敬请等待审核结果！</div>'
      }

      if (checkFilterTool.isPassCheck(status)) {
        this.statusWarningHtml = '<div style="background: #f0fff2; padding: 0.62500rem 0.93750rem;">恭喜您已通过学校报名资格审核！</div>'
      }

      if (checkFilterTool.isRefuseCheck(status)) {
        this.statusWarningHtml = `<div style="background: #fcefe6; padding: 0.62500rem 0.93750rem;">审核不通过意见：${this.enrollConfigAllData.shrzList[0]?.shyj || ''}</div>`
      }
    },

    async recycle () {
      const { code, message } = await cancelEnroll({ wid: this.userData.wid })

      if (+code === 0) {
        this.setEnrollConfigAllData()
        success('操作成功')
      } else {
        danger(message)
      }
    },

    async nextStep (menu) {
      const { link } = menu

      if (!this.canEdit && !this.isModify) {
        return
      }

      if (!this.userData.wid && link !== 'baseInfoWrite') {
        toast('请先填写基本信息')

        return
      }

      if (link === 'voluntInfoWrite') {
        const { code } = await checkBaseRequire({ wid: this.userData.wid })

        if (code !== 0) {
          toast('请先完善基本信息必填字段，才可以开始填报志愿信息！')

          return
        }
      }

      this.$emit('on-change-component', link, { options: this.enrollConfigAllData })
    },

    preBack () {
      this.$router.push('./enrollNotice')
    },

    async handlerDownloadTemplateTable () {
      if (this.userData.wid == null) {
        toast('请先填写基本信息')

        return
      }

      const { data, code } = await downloadEnrollTable({ wid: this.userData.wid })

      if (code === 0) {
        const a = document.createElement('a')

        a.setAttribute('href', data)
        a.click()
      }
    },

    handlerPreview () {
      this.$emit('on-change-component', 'TEnrollDetail')
    },

    async submit () {
      let waringMsg = ''

      if (!this.userData.wid) {
        toast('请填写基本信息')

        return
      }

      for (let i = 0; i < this.menuList.length; i++) {
        const obj = this.menuList[i]

        if (obj.isRequired && obj.isDisplay && !obj.hasWriteFlag) {
          waringMsg = `请填写${obj.title}`

          break
        }
      }

      if (waringMsg) {
        toast(waringMsg)

        return
      }

      await confirm({
        title: '提示',
        message: '确定提交吗？一旦提交，可能无法进行修改，请慎重！',
        beforeConfirm: async (done) => {
          const { code, message } = await submitEnroll({ wid: this.userData.wid })

          if (+code === 0) {
            success('恭喜您，提交成功，请等待审核！')
            this.$router.push('/enroll')

            // this.setEnrollConfigAllData()
            done()
          } else {
            danger(message)
            done()
          }
        },
      })
    },

  },
}
